import {Component, OnInit} from "@angular/core";
import {New} from "./new";
import {NewService} from "./new.service";
import {Router} from "@angular/router";
declare var jquery:any; // 這邊用 var 
declare let $:any; // 當然 let 也可以

@Component({
  template:`    
    <div class="big-about">
       
        <div class="middle-box"><br>
        <h2>最新消息</h2><br>
        <div class="line-about"></div><br>
        <p>關於本店近況及商品的最新消息皆會在此不定期發佈！！！
        </p>
        </div></div>
        <div class="container">
        <div class="title-clothes">
        <div class="title-clothes-line"></div>最新消息<div class="title-clothes-line2"></div>
        </div>
        <div class="categoryBtn">
        <button class="newBtn2" (click)="gotoNew()">全部</button>

        <button class="newBtn2" (click)="gotoNew2()">活動</button>
        <button class="newBtn2" (click)="gotoNew3()">評測</button>
        <button class="newBtn2" (click)="gotoNew4()">新品</button>
        <button class="newBtn2" (click)="gotoNew5()">重要</button>
        <button class="newBtn2" (click)="gotoNew6()">情報</button>
        </div>
        <div class="cool"><button class="changefont" (click)="gotoDetail220()">2020-08-09<span class="category">情報</span><p class="cool2"></p>2020 桌球器材流行新趨勢 - 黏性內能膠皮💥💥</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail219()">2020-07-23<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 運動毛巾【日本今治認證】登場！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail218()">2020-07-19<span class="category">新品</span><p class="cool2"></p>"MIZUNO" Sumikko Gurashi 限量聯名款訓練T恤</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail217()">2020-07-18<span class="category">新品</span><p class="cool2"></p>"MIZUNO" 美津濃東京奧運限定鞋款 火熱到貨～！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail216()">2020-07-14<span class="category">新品</span><p class="cool2"></p>"VICTAS" LIAM PITCHFORD 全新底板正式上市🎊</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail215()">2020-07-10<span class="category">新品</span><p class="cool2"></p>"XIOM"36.5 ALX 底板 開賣囉～</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail214()">2020-07-03<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"「林昀儒」桌球拍 新上市!</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail213()">2020-06-30<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"最新款黏性膠皮AIBISS 發燒到貨</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail212()">2020-06-23<span class="category">新品</span><p class="cool2"></p>"Mizuno" 美津濃短袖運動T恤【台灣限定】</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail211()">2020-06-20<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"【AIBISS】全新黏性膠皮的新選擇</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail210()">2020-06-18<span class="category">新品</span><p class="cool2"></p>"STIGA" 時尚潮運動裝備袋</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail209()">2020-06-10<span class="category">新品</span><p class="cool2"></p>"Mizuno" 2020 新款桌球鞋(限定色)到貨</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail208()">2020-06-02<span class="category">新品</span><p class="cool2"></p>"STIGA" 碳素紀元Leagcy Carbon國際版</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail207()">2020-05-19<span class="category">新品</span><p class="cool2"></p>【DONICx哆啦A夢】桌球T恤聯名C款</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail206()">2020-05-10<span class="category">新品</span><p class="cool2"></p>"ARIEX" 艾銳斯Trigram SUPER ZLC(台灣製)</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail205()">2020-05-07<span class="category">新品</span><p class="cool2"></p>"Nittaku" 100 週年慶限量飛行夾克開賣</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail204()">2020-05-04<span class="category">新品</span><p class="cool2"></p>"Mizuno" WAVE KAISERBURG 6 新品熱賣中！</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail203()">2020-04-13<span class="category">活動</span><p class="cool2"></p>【波爾桌球】四月優惠活動開跑</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail202()">2020-03-27<span class="category">新品</span><p class="cool2"></p>"MIZUNO"2020 美津濃新款運動服到貨</button><br><br></div> 
        <div class="cool"><button class="changefont" (click)="gotoDetail201()">2020-03-19<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"2020新品 3/19提前到貨！</button><br><br></div> 

        <button class="newBtn" (click)="show1()" *ngIf="more1 == false">更多消息</button>

        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail200()">2020-03-10<span class="category">重要</span><p class="cool2"></p>台北萬隆體驗店【營業時間變更公告】</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail199()">2020-03-08<span class="category">活動</span><p class="cool2"></p>"BUTTERFLY"2020年『旗艦產品限量預購活動』</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail198()">2020-03-05<span class="category">新品</span><p class="cool2"></p>"STIGA"樊振東個人專屬底板-樊系橙標 即將上市</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail197()">2020-02-21<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"『超級張本ZLC』即將上市</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail196()">2020-02-19<span class="category">情報</span><p class="cool2"></p>『波爾桌球』贊助選手"張佑安",勇奪國際公開賽金牌</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail195()">2020-01-21<span class="category">重要</span><p class="cool2"></p>春節營業時間出爐嘍‼️I can do it~再度挑戰全年無休</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail194()">2020-01-20<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY" What is Dignics 09C?</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail193()">2020-01-19<span class="category">情報</span><p class="cool2"></p>新北捷運環狀線今天 (1/19) 開放試乘囉！💯💯💯</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail192()">2020-01-13<span class="category">情報</span><p class="cool2"></p>瑞典"STIGA"執行長Mr. Ola Werner 蒞臨考察</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail191()">2020-01-07<span class="category">情報</span><p class="cool2"></p>2020 "MIZUNO"簽下長崎美柚 Nagasaki Miyuu</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail190()">2020-01-01<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY"宣佈簽下前球王『奧洽洛夫』</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail189()">2019-12-16<span class="category">活動</span><p class="cool2"></p>『STIGA 首款德製DNA膠皮講習會』開放報名～</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail188()">2019-12-13<span class="category">情報</span><p class="cool2"></p>賀！波爾代表『尤思宏』勇奪年終單打菁英賽冠軍🏆</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail187()">2019-12-12<span class="category">情報</span><p class="cool2"></p>『陳思羽』首場加油見面會在波爾桌球 敬請期待！</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail186()">2019-12-09<span class="category">活動</span><p class="cool2"></p>2020年波爾桌球桌曆-- 風一樣的女子『劉昱昕』</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail185()">2019-11-26<span class="category">新品</span><p class="cool2"></p>"Mizuno" 不敗的經典設計/基本款桌球鞋</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail184()">2019-11-22<span class="category">新品</span><p class="cool2"></p>"Mizuno" 2020 桌球運動鞋 公司進口限定色上市 💫</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail183()">2019-11-15<span class="category">情報</span><p class="cool2"></p>"波爾桌球"2020年度代言人 - 國手♡劉昱昕♡</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail182()">2019-11-11<span class="category">新品</span><p class="cool2"></p>"STIGA" DNA系列膠皮 "德國意志"，火熱開賣中!!!</button><br><br></div> 
        <div class="cool" *ngIf="more1"><button class="changefont" (click)="gotoDetail181()">2019-11-01<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"新品到貨～林高遠ALC、D64、D80</button><br><br></div> 

        <button class="newBtn" (click)="show2()" *ngIf="more1==true && more2 == false">更多消息</button>

        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail180()">2019-10-26<span class="category">活動</span><p class="cool2"></p>"BUTTERFLY"林高遠ALC、D64、D80 預約試打</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail179()">2019-10-25<span class="category">重要</span><p class="cool2"></p>【波爾桌球-萬隆體驗店】國民旅遊卡開放囉！🆕💯</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail178()">2019-10-25<span class="category">新品</span><p class="cool2"></p>"STIGA" DNA PRO 平面膠皮，即將到貨！</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail177()">2019-10-13<span class="category">新品</span><p class="cool2"></p>流行時尚的"XIOM"軍團秘密武器再次發佈</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail176()">2019-10-12<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" D64、D80平面膠皮 即將震撼上市</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail175()">2019-09-30<span class="category">重要</span><p class="cool2"></p>【波爾桌球用品專賣店】營業時間異動公告</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail174()">2019-09-06<span class="category">新品</span><p class="cool2"></p>BUTTERFLY 2019 秋冬新製品登場！🏓🏓🏓</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail173()">2019-09-02<span class="category">情報</span><p class="cool2"></p>Ezvid Wiki《2019年度十大桌球拍》</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail172()">2019-08-23<span class="category">活動</span><p class="cool2"></p>開學季門市鞋類商品特價 📣 萬隆體驗站限定 📣</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail171()">2019-08-05<span class="category">活動</span><p class="cool2"></p>波爾桌球萬隆體驗站限時優惠 👉 至8月31前</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail170()">2019-07-26<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"最新款 LOGO 字樣蝴蝶拍套上市</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail169()">2019-07-25<span class="category">新品</span><p class="cool2"></p>"TIBHAR" MX-P 50 HARD（50°）平面膠皮到貨</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail168()">2019-07-21<span class="category">情報</span><p class="cool2"></p>賀！T2 Diamond Malaysia男單冠軍-林昀儒</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail167()">2019-07-12<span class="category">新品</span><p class="cool2"></p>"STIGA"國際級進口專業比賽級球桌火熱開賣</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail166()">2019-07-11<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"LEZOLINE-JL II兒童鞋款 抵台上市</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail165()">2019-06-22<span class="category">活動</span><p class="cool2"></p>2019『怡靜』與台灣桌球粉絲的美麗見面會</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail164()">2019-06-15<span class="category">活動</span><p class="cool2"></p>2019台灣一姐鄭怡靜-6月22日台北見面會在"波爾"</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail163()">2019-06-12<span class="category">新品</span><p class="cool2"></p>STIGA瑞典原裝進口桌球運動服飾👕 亮相 ✨💯✨</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail162()">2019-06-08<span class="category">情報</span><p class="cool2"></p>延續氣勢再奪2019香港公開賽混雙冠軍！🏆🏆</button><br><br></div> 
        <div class="cool" *ngIf="more2"><button class="changefont" (click)="gotoDetail161()">2019-06-01<span class="category">情報</span><p class="cool2"></p>賀！"林昀儒／鄭怡靜" 中國公開賽勇奪混雙冠軍🏆</button><br><br></div> 

        <button class="newBtn" (click)="show3()" *ngIf="more2==true && more3 == false">更多消息</button>

        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail160()">2019-05-29<span class="category">新品</span><p class="cool2"></p>2019夏季美津濃(Mizuno)桌球器材重裝出擊 ‼️‼️‼️</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail159()">2019-05-26<span class="category">情報</span><p class="cool2"></p>賀！波爾贊助球員「尤思宏」泛美運動會資格賽第一</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail158()">2019-05-20<span class="category">新品</span><p class="cool2"></p>🇸🇪 STIGA 75周年底板-特製Clipper紀念板到貨 🇸🇪 </button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail157()">2019-05-18<span class="category">情報</span><p class="cool2"></p>2019年4月份全日本桌球底板與膠皮銷售排行榜</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail156()">2019-05-17<span class="category">情報</span><p class="cool2"></p>賀！波爾桌球贊助選手「張佑安」當選國手(15歲組)</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail155()">2019-05-15<span class="category">情報</span><p class="cool2"></p>"Made in Taiwan" - ARIEX艾銳斯桌球品牌</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail154()">2019-05-04<span class="category">活動</span><p class="cool2"></p>台灣一姊鄭怡靜(世界排名No.8)球迷簽名見面會</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail153()">2019-05-03<span class="category">新品</span><p class="cool2"></p>"DHS紅雙喜"狂飆龍5X、世界巡迴賽乒乓用球 到貨</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail152()">2019-05-03<span class="category">情報</span><p class="cool2"></p>典藏"BUTTERFLT"🇯🇵福原愛ZLF🇹🇼最後機會</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail151()">2019-04-30<span class="category">新品</span><p class="cool2"></p>2019 最具話題的"XIOM"時尚拍套總整理🎊🎉</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail150()">2019-04-28<span class="category">情報</span><p class="cool2"></p>2019 布達佩斯世錦賽 🏆男單金牌 - 馬龍🏆</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail149()">2019-04-28<span class="category">情報</span><p class="cool2"></p>2019 布達佩斯世錦賽 🏆女單金牌 - 劉詩雯🏆</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail148()">2019-04-20<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 2019春季商品原裝空運 新貨到～</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail147()">2019-04-11<span class="category">活動</span><p class="cool2"></p>"波爾萬隆體驗站" 好禮大放送 周年慶抽不完</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail146()">2019-04-07<span class="category">情報</span><p class="cool2"></p>"坂本龍介"將參與日本MIZUNO桌球產品營銷及開發</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail145()">2019-04-04<span class="category">新品</span><p class="cool2"></p>"DHS紅雙喜" 新版 狂飆龍5X(馬龍用)上市</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail144()">2019-04-02<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" DIGNICS 05🆕 上市開賣</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail143()">2019-03-21<span class="category">活動</span><p class="cool2"></p>波爾桌球萬隆店一週年抽獎活動</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail142()">2019-03-21<span class="category">新品</span><p class="cool2"></p>"Nittaku" 2019全系列服飾 即將上市</button><br><br></div> 
        <div class="cool" *ngIf="more3"><button class="changefont" (click)="gotoDetail141()">2019-03-16<span class="category">新品</span><p class="cool2"></p>"STIGA" 2019 春夏桌球運動圓領 T-SHIRT</button><br><br></div> 

        <button class="newBtn" (click)="show4()" *ngIf="more3==true && more4 == false">更多消息</button>

        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail140()">2019-03-13<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"DIGNICS 05 最新款膠皮 即將到貨</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail139()">2019-03-05<span class="category">情報</span><p class="cool2"></p>即日起"BUTTERFLY" Viscaria FL/ST 建議售價調漲</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail138()">2019-02-23<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY"日本原裝進口抗菌除臭運動襪到貨</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail137()">2019-02-22<span class="category">情報</span><p class="cool2"></p>2019 "BUTTERFLY" VISCARIA ST 復刻再現👍👍👍</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail136()">2019-02-21<span class="category">新品</span><p class="cool2"></p>"STIGA"新品系列 塩野真人共同開發🥇🥇🥇</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail135()">2019-02-16<span class="category">新品</span><p class="cool2"></p>XIOM底板 冰淇淋"ICE CREAM" 火熱到貨❗</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail134()">2019-02-15<span class="category">新品</span><p class="cool2"></p>許昕藍標限量(and黑標)底板限量到貨，欲購從速~~~ </button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail133()">2019-02-11<span class="category">重要</span><p class="cool2"></p>波爾桌球『中和店』開放使用國民旅遊卡～</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail132()">2019-02-02<span class="category">重要</span><p class="cool2"></p>『萬隆店』💮農曆年節期間，2/4(一)~2/8(五)店休</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail131()">2019-02-02<span class="category">重要</span><p class="cool2"></p>『中和總店』春節營業時間出爐~首度挑戰全年無休!!</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail130()">2019-01-30<span class="category">評測</span><p class="cool2"></p>全台首發 『莊智淵 15th 限量紀念拍』 試打評測</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail129()">2019-01-29<span class="category">新品</span><p class="cool2"></p>『莊智淵簽約15周年全球限量紀念拍』 首批到貨～</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail128()">2019-01-29<span class="category">新品</span><p class="cool2"></p>德國桌球大廠 DONIC 新款T-SHIRT 開始販售</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail127()">2019-01-24<span class="category">新品</span><p class="cool2"></p>STIGA 2019 春夏桌球運動圓領 T-Shirt 開始販售</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail126()">2019-01-21<span class="category">情報</span><p class="cool2"></p>「大島祐哉」榮獲全日本卓球錦標賽 男單亞軍🥈</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail125()">2019-01-12<span class="category">新品</span><p class="cool2"></p>好消息!!! STIGA GENESIS II 📣 2019上市 📣</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail124()">2019-01-10<span class="category">新品</span><p class="cool2"></p>2019 "Mizuno"新款抗紫外線短袖T恤</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail123()">2019-01-07<span class="category">活動</span><p class="cool2"></p>我和🏓桌球女神「鄭先知」有個約會2019🎉👍🙏</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail122()">2019-01-07<span class="category">新品</span><p class="cool2"></p>➡️ 壓倒性的進化 Dignics 05 ⬅️</button><br><br></div> 
        <div class="cool" *ngIf="more4"><button class="changefont" (click)="gotoDetail121()">2019-01-03<span class="category">情報</span><p class="cool2"></p>韓國品牌XIOM與Hugo Calderano 簽約</button><br><br></div> 

        <button class="newBtn" (click)="show5()" *ngIf="more4==true && more5 == false">更多消息</button>

        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail120()">2018-12-28<span class="category">情報</span><p class="cool2"></p>「桌球勵志哥」葉致緯的故事...</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail119()">2018-12-20<span class="category">活動</span><p class="cool2"></p>桌球女神『鄭先知』簽名握手會🏃🏻🏃🏻🏃🏻</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail118()">2018-12-20<span class="category">新品</span><p class="cool2"></p>"STIGA" SYMMETRY 新貨到👀👀👀</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail117()">2018-12-14<span class="category">活動</span><p class="cool2"></p>2018 Christmas Sales 感恩回饋活動🎁🎄⛄❄️</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail116()">2018-12-09<span class="category">活動</span><p class="cool2"></p>桌球明星『鄭先知』簽名握手會 COMING SOON...</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail115()">2018-12-06<span class="category">情報</span><p class="cool2"></p>韓國"XIOM" 2019年新拍即將上市</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail114()">2018-12-05<span class="category">情報</span><p class="cool2"></p>BUTTERFLY "張本智和"底板 呼之欲出😎</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail113()">2018-12-02<span class="category">新品</span><p class="cool2"></p>2018友誼729 全新款藍芳碳纖維桌球底板</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail112()">2018-11-30<span class="category">新品</span><p class="cool2"></p>"Nittaku"日本製三星新塑料橘色比賽球</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail111()">2018-11-26<span class="category">新品</span><p class="cool2"></p>"MIZUNO" 2019春夏新款桌球鞋提前上市 獨步全台</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail110()">2018-11-24<span class="category">情報</span><p class="cool2"></p>蝴蝶牌 "BUTTERFLY" 新總部落成典禮</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail109()">2018-11-21<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 莊智淵全球限量紀念拍 預購開跑!</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail108()">2018-11-20<span class="category">新品</span><p class="cool2"></p>"MIZUNO" 2018秋冬款運動童鞋 💫 正品上市 💫 </button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail107()">2018-11-14<span class="category">情報</span><p class="cool2"></p>謎一樣的"BUTTERFLY" Dignics系列</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail106()">2018-11-10<span class="category">情報</span><p class="cool2"></p>"XIOM" 無機膠水不貼在膠皮上❓❓❓</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail105()">2018-11-03<span class="category">新品</span><p class="cool2"></p>"STGIA" Dynasty Carbon限量到貨開放預約</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail104()">2018-11-01<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" Tenergy 05 Hard 🔥火熱到貨🔥</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail103()">2018-10-30<span class="category">新品</span><p class="cool2"></p>NEW 2018 "DONIC"秋冬T-SHIRT 上市</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail102()">2018-10-26<span class="category">新品</span><p class="cool2"></p>2018新款蝴蝶牌 TIMO BOLL 系列 即將到貨！</button><br><br></div> 
        <div class="cool" *ngIf="more5"><button class="changefont" (click)="gotoDetail101()">2018-10-16<span class="category">情報</span><p class="cool2"></p>"STIGA" 許昕的神祕武器👀 👀 👀</button><br><br></div> 

        <button class="newBtn" (click)="show6()" *ngIf="more5==true && more6 == false">更多消息</button>

        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail100()">2018-10-15<span class="category">活動</span><p class="cool2"></p>【波爾桌球×美津濃桌球教室】成功圓滿結束</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail99()">2018-10-09<span class="category">新品</span><p class="cool2"></p>"STIGA" 秋冬T-Shirt 現正販售中</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail98()">2018-09-21<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY"正式簽約中國選手★林高遠★</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail97()">2018-09-20<span class="category">重要</span><p class="cool2"></p>【波爾桌球中秋假期營業時間公告】</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail96()">2018-09-14<span class="category">情報</span><p class="cool2"></p>"BUTTERFLY"新產品 11月即將推出～</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail95()">2018-09-13<span class="category">活動</span><p class="cool2"></p>9月開學感謝大特賣(9/14~9/30 限萬隆)</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail94()">2018-09-12<span class="category">活動</span><p class="cool2"></p>【波爾桌球×美津濃桌球教室】熱烈報名中！</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail93()">2018-09-11<span class="category">活動</span><p class="cool2"></p>波爾桌球"年中會員禮"活動開跑來囉！！</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail92()">2018-09-11<span class="category">重要</span><p class="cool2"></p>【萬隆體驗站-營業時間更改公告】</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail91()">2018-09-08<span class="category">新品</span><p class="cool2"></p>全新款"MIZUNO"男女運動排汗衫</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail90()">2018-09-07<span class="category">評測</span><p class="cool2"></p>常見品牌的練習球的差異性</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail89()">2018-09-06<span class="category">活動</span><p class="cool2"></p>"STIGA" AIROC astro/MANTRA 價格調整</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail88()">2018-09-02<span class="category">評測</span><p class="cool2"></p>"Nittaku" Factive Carbon 底板評測</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail87()">2018-08-31<span class="category">新品</span><p class="cool2"></p>迷你乒乓小球桌，【波爾桌球用品專賣店】買得到</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail86()">2018-08-27<span class="category">活動</span><p class="cool2"></p>賀亞運棒球終於贏了南韓隊，STIGA球拍買一送一</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail85()">2018-08-21<span class="category">活動</span><p class="cool2"></p>今年暑假最後一檔 - 加價購/滿額贈 🔥🔥🔥</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail87()">2018-08-31<span class="category">新品</span><p class="cool2"></p>迷你乒乓小球桌，【波爾桌球用品專賣店】買得到</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail86()">2018-08-27<span class="category">活動</span><p class="cool2"></p>賀亞運棒球終於贏了南韓隊，STIGA球拍買一送一</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail85()">2018-08-21<span class="category">活動</span><p class="cool2"></p>今年暑假最後一檔 - 加價購/滿額贈 🔥🔥🔥</button><br><br></div> 
        <div class="cool" *ngIf="more6"><button class="changefont" (click)="gotoDetail84()">2018-08-19<span class="category">評測</span><p class="cool2"></p>"STIGA" AZALEA(杜鵑)OFFENSIVE評測</button><br><br></div> 

        <button class="newBtn" (click)="show7()" *ngIf="more6==true && more7 == false">更多消息</button>

        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail83()">2018-08-17<span class="category">新品</span><p class="cool2"></p>"Mizuno" 台灣款配色運動鞋特價供應 💪💪💪</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail82()">2018-08-10<span class="category">新品</span><p class="cool2"></p>STIGA“杜鵑花”系列全面盛開怒放【新貨入荷】</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail81()">2018-08-07<span class="category">情報</span><p class="cool2"></p>BUTTERFLY蝴蝶牌「朱世赫」削球底板正式停產</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail80()">2018-08-01<span class="category">活動</span><p class="cool2"></p>BUTTERFLY ROZENA 膠皮(破盤大特價！)</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail79()">2018-07-28<span class="category">新品</span><p class="cool2"></p>DONIC 2018 夏季圓領T恤上市💓💓💓</button><br><br></div>
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail78()">2018-07-25<span class="category">情報</span><p class="cool2"></p>"ITC"(最新韓國桌球品牌)之新嘗試新體驗</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail77()">2018-07-23<span class="category">新品</span><p class="cool2"></p>XIOM VEGA TOUR(金V)內能膠皮到貨📣📢</button><br><br></div>
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail76()">2018-07-19<span class="category">評測</span><p class="cool2"></p>Nostalgic傳奇7 試打，STIGA持續締造不敗神話</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail75()">2018-07-19<span class="category">新品</span><p class="cool2"></p>BUTTERFLY蝴蝶牌2018原創限量 T 預購開跑 ❤️💕</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail74()">2018-07-18<span class="category">評測</span><p class="cool2"></p>BUTTERFLY APOLONIA ZLC 底版 試打評測</button><br><br></div>
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail73()">2018-07-14<span class="category">新品</span><p class="cool2"></p>2018 "STIGA" 絕殺武器紅豆木底板三款到貨</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail72()">2018-07-12<span class="category">新品</span><p class="cool2"></p>"美津濃" MIZUNO桌球膠皮 Q4 台灣首發上市</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail71()">2018-07-10<span class="category">新品</span><p class="cool2"></p>"美津濃"WAVE MEDAL 5 新款桌球鞋，搶先登場！</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail70()">2018-07-02<span class="category">新品</span><p class="cool2"></p>"STIGA" 2018 NOSTALGIC 傳奇系列–即將到貨</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail69()">2018-06-24<span class="category">評測</span><p class="cool2"></p>“美津濃“Q系列膠皮再進化，Q4搶先試打實測</button><br><br></div>
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail68()">2018-06-17<span class="category">新品</span><p class="cool2"></p>"美津濃"桌球膠皮 2018 大進擊，全新Q4實拍</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail67()">2018-06-13<span class="category">新品</span><p class="cool2"></p>"BUTTERFLY" 2018夏季鞋款 與日本同步上市</button><br><br></div>
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail66()">2018-06-08<span class="category">新品</span><p class="cool2"></p>"美津濃,Nittaku,DONIC"新款運動短褲🔥火熱🔥上市</button><br><br></div> 
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail65()">2018-05-23<span class="category">新品</span><p class="cool2"></p>“美津濃"2018夏季最新款桌球鞋台灣上架囉～</button><br><br></div>
        <div class="cool" *ngIf="more7"><button class="changefont" (click)="gotoDetail64()">2018-05-21<span class="category">評測</span><p class="cool2"></p>XIOM BRAVO ABS40+ 三星比賽球實測短評</button><br><br></div> 

        <button class="newBtn" (click)="show8()" *ngIf="more7==true && more8 == false">更多消息</button>

        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail63()">2018-05-18<span class="category">新品</span><p class="cool2"></p>只送不賣DHS雙色乒乓球(至門市FB打卡 即贈2顆)</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail62()">2018-05-15<span class="category">評測</span><p class="cool2"></p>"YASAKA" Alnade底板 獨家試打評論</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail61()">2018-05-11<span class="category">情報</span><p class="cool2"></p>感謝台灣美津濃公司總經理 周宏津先生 蒞臨指導</button><br><br></div>
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail60()">2018-05-07<span class="category">情報</span><p class="cool2"></p>波爾桌球贊助球員 "王元佑" 勇奪大專校友盃 季軍</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail59()">2018-04-29<span class="category">活動</span><p class="cool2"></p>"MIZUNO美津濃"桌球膠皮Q3+專業底板試打會</button><br><br></div>
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail61()">2018-05-11<span class="category">情報</span><p class="cool2"></p>感謝台灣美津濃公司總經理 周宏津先生 蒞臨指導</button><br><br></div>
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail60()">2018-05-07<span class="category">情報</span><p class="cool2"></p>波爾桌球贊助球員 "王元佑" 勇奪大專校友盃 季軍</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail59()">2018-04-29<span class="category">活動</span><p class="cool2"></p>"MIZUNO美津濃"桌球膠皮Q3+專業底板試打會</button><br><br></div>
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail58()">2018-04-29<span class="category">情報</span><p class="cool2"></p>🎊賀🎊 波爾桌球隊勇奪107年度大同區主委盃 亞軍</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail57()">2018-04-26<span class="category">新品</span><p class="cool2"></p>2018 日本“BUTTERFLY” 春夏季款商品到貨！</button><br><br></div>
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail56()">2018-04-22<span class="category">評測</span><p class="cool2"></p>美津濃 Mizuno Fortius FT ver.D 獨家試打評論</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail55()">2018-04-19<span class="category">新品</span><p class="cool2"></p>"STIGA" LINER II 紅白 專業桌球鞋🌟 新貨到港 🌟</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail54()">2018-04-18<span class="category">重要</span><p class="cool2"></p>【波爾桌球用品專賣店】即將進行今年第二次改裝！</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail53()">2018-04-15<span class="category">新品</span><p class="cool2"></p>【BTY 新製品介紹】2018 Spring Summer 春夏服裝</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail52()">2018-04-14<span class="category">評測</span><p class="cool2"></p>美津濃 "Mizuno" Carbosonic 底板 獨家實測</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail51()">2018-04-13<span class="category">評測</span><p class="cool2"></p>"Mizuno" GF Pro與Q3 兩款膠皮獨家試打評測</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail50()">2018-04-11<span class="category">活動</span><p class="cool2"></p>"波爾桌球-萬隆體驗站"感恩回饋第二波</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail49()">2018-04-05<span class="category">新品</span><p class="cool2"></p>日本"Mizuno"桌球鞋全系列到貨～欲購從速!!!</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail48()">2018-04-02<span class="category">新品</span><p class="cool2"></p>日本"Nittaku"2018年台灣製台版服飾隆重上市</button><br><br></div> 
        <div class="cool" *ngIf="more8"><button class="changefont" (click)="gotoDetail47()">2018-03-26<span class="category">重要</span><p class="cool2"></p>波爾桌球「台北萬隆體驗站」4/1(日)正式開幕！</button><br><br></div>

        <button class="newBtn" (click)="show9()" *ngIf="more8==true && more9 == false">更多消息</button>

        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail46()">2018-03-21<span class="category">情報</span><p class="cool2"></p>日本"BUTTERFLY"2018 春夏產品型錄搶先看！</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail45()">2018-03-20<span class="category">情報</span><p class="cool2"></p>“Nittaku” 檜木系列漲價公告</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail44()">2018-03-17<span class="category">新品</span><p class="cool2"></p>美津濃(Mizuno) 桌球用品火熱到貨!!!</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail43()">2018-03-16<span class="category">情報</span><p class="cool2"></p>好消息📣📣📣 "STIGA" 桌球底板 大降價!!</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail42()">2018-03-15<span class="category">評測</span><p class="cool2"></p>"BTY"桌球底板兩大魔王 Boll ALC與Viscaria</button><br><br></div>
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail41()">2018-03-09<span class="category">新品</span><p class="cool2"></p>🎉"STIGA" 透氣排汗上衣-新上市🎉</button><br><br></div>
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail40()">2018-03-08<span class="category">活動</span><p class="cool2"></p>日本"BUTTERFLY"桌球鞋 5折特賣活動開跑囉！</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail39()">2018-03-03<span class="category">情報</span><p class="cool2"></p>賀★波爾桌球★成為"美津濃MIZUNO"簽約經銷商</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail38()">2018-02-10<span class="category">情報</span><p class="cool2"></p>波爾桌球「台北萬隆體驗站」即將開幕</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail37()">2018-02-10<span class="category">重要</span><p class="cool2"></p>【2018 農曆新年營業時間】</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail39()">2018-03-03<span class="category">情報</span><p class="cool2"></p>賀★波爾桌球★成為"美津濃MIZUNO"簽約經銷商</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail38()">2018-02-10<span class="category">情報</span><p class="cool2"></p>波爾桌球「台北萬隆體驗站」即將開幕</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail37()">2018-02-10<span class="category">重要</span><p class="cool2"></p>【2018 農曆新年營業時間】</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail38()">2018-02-10<span class="category">情報</span><p class="cool2"></p>波爾桌球「台北萬隆體驗站」即將開幕</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail37()">2018-02-10<span class="category">重要</span><p class="cool2"></p>【2018 農曆新年營業時間】</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail36()">2018-02-07<span class="category">新品</span><p class="cool2"></p>“BUTTERFLY”A40+ 3星比賽級塑料球上市</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail35()">2018-02-03<span class="category">評測</span><p class="cool2"></p>乒乓之神的終極神器～水滴型瓦木與瓦碳</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail34()">2018-01-12<span class="category">評測</span><p class="cool2"></p>"Nittaku S-cz" 德國製底板試打報告</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail33()">2017-12-29<span class="category">活動</span><p class="cool2"></p>2017感恩大回饋"年終會員禮"來囉～</button><br><br></div> 
        <div class="cool" *ngIf="more9"><button class="changefont" (click)="gotoDetail32()">2017-12-25<span class="category">評測</span><p class="cool2"></p>“XIOM OMEGA 7” 開箱試打分享</button><br><br></div> 

        <button class="newBtn" (click)="show10()" *ngIf="more9==true && more10 == false">更多消息</button>

        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail31()">2017-12-23<span class="category">新品</span><p class="cool2"></p>XIOM 最新FEEL系列底板在台灣上市囉～～</button><br><br></div>
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail30()">2017-12-21<span class="category">新品</span><p class="cool2"></p>XIOM OMEGA VII PRO 專業桌球膠皮到貨啦～</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail29()">2017-12-19<span class="category">新品</span><p class="cool2"></p>Ｎittaku S-Series系列底版(德國製)</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail28()">2017-12-18<span class="category">情報</span><p class="cool2"></p>2017國際桌總巡迴賽總決賽冠軍-STIGA之星＊樊振東</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail27()">2017-12-16<span class="category">評測</span><p class="cool2"></p>”YASAKA Extra Offensive“ 試打分享</button><br><br></div>
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail26()">2017-12-03<span class="category">其他</span><p class="cool2"></p>世界桌球金牌選手✩陳建安✩訓練影片</button><br><br></div>
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail25()">2017-12-02<span class="category">新品</span><p class="cool2"></p>燒騰騰～『TIBHAR』專業兒童桌球鞋</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail24()">2017-11-25<span class="category">新品</span><p class="cool2"></p>『TIBHAR』新款運動後背包</button><br><br></div>
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail23()">2017-11-25<span class="category">情報</span><p class="cool2"></p>"ITTF" 國際桌總再次更換比賽用球??!!</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail22()">2017-11-23<span class="category">新品</span><p class="cool2"></p>BUTTERFLY 吉村真晴『親筆簽名限量拍』</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail21()">2017-11-22<span class="category">評測</span><p class="cool2"></p>"Nittaku Bloodwood"帥氣開箱分享</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail20()">2017-11-14<span class="category">評測</span><p class="cool2"></p>STIGA 北極純木五夾 ARCTIC 開箱體驗</button><br><br></div>
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail19()">2017-11-12<span class="category">情報</span><p class="cool2"></p>日本蝴蝶牌”BUTTERFLY”桌球底板的誕生 </button><br><br></div>
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail18()">2017-11-09<span class="category">新品</span><p class="cool2"></p>㊣ Arctic Wood ㊣ STIGA底板 新品上市</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail17()">2017-11-02<span class="category">新品</span><p class="cool2"></p>BUTTERFLY CHACK SHEET 專業無機黏膠紙</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail18()">2017-11-09<span class="category">新品</span><p class="cool2"></p>㊣ Arctic Wood ㊣ STIGA底板 新品上市</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail17()">2017-11-02<span class="category">新品</span><p class="cool2"></p>BUTTERFLY CHACK SHEET 專業無機黏膠紙</button><br><br></div> 
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail16()">2017-10-27<span class="category">情報</span><p class="cool2"></p>⭐"BUTTERFLY 波爾ALC"底板持續熱銷中⭐</button><br><br></div>  
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail15()">2017-10-19<span class="category">評測</span><p class="cool2"></p>"BUTTERFLY INNERFORCE ZLC"評測分享</button><br><br></div>  
        <div class="cool" *ngIf="more10"><button class="changefont" (click)="gotoDetail14()">2017-10-15<span class="category">活動</span><p class="cool2"></p>獨 ❗️家 ❗️商 ❗️品 ❗️限時預購～</button><br><br></div> 

        <button class="newBtn" (click)="show11()" *ngIf="more10==true && more11 == false">更多消息</button>

        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail12()">2017-10-08<span class="category">重要</span><p class="cool2"></p>【國慶連假營業時間異動】</button><br><br></div>  
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail9()">2017-10-06<span class="category">評測</span><p class="cool2"></p>七夾經典"Avalox-AVX P700" 評測分享</button><br><br></div> 
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail8()">2017-10-06<span class="category">情報</span><p class="cool2"></p>蝴蝶牌 BUTTERFLY 2017 秋冬新產品目錄發行囉！</button><br><br></div> 
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail10()">2017-10-03<span class="category">重要</span><p class="cool2"></p>【中秋節營業時間異動】</button><br><br></div> 
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail13()">2017-10-01<span class="category">新品</span><p class="cool2"></p>2017 秋冬新款 STIGA 無領短T排汗衣</button><br><br></div>
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail11()">2017-09-22<span class="category">評測</span><p class="cool2"></p>"STIGA AIROC系列"膠皮實測</button><br><br></div>        
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail2()">2017-08-31<span class="category">情報</span><p class="cool2"></p>日本十大暢銷膠皮排行</button><br><br></div>     
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail6()">2017-08-11<span class="category">新品</span><p class="cool2"></p>Palio 拍里奧新材料ABS 40+ 一星級訓練用球</button><br><br></div>  
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail7()">2017-07-25<span class="category">重要</span><p class="cool2"></p>【營業時間更改公告】</button><br><br></div> 
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail4()">2017-07-25<span class="category">評測</span><p class="cool2" ></p>XlOM Musa Asia 五夾純木底板評測分享</button><br><br></div> 
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail1()">2017-07-06<span class="category">活動</span><p class="cool2"></p>FB現場直播 * 送球拍 * 活動預告</button><br><br></div>  
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail5()">2017-07-05<span class="category">新品</span><p class="cool2"></p>DONIC BLUE STORM 火熱到貨！！</button><br><br></div>  
        <div class="cool" *ngIf="more11"><button class="changefont" (click)="gotoDetail3()">2017-06-18<span class="category">情報</span><p class="cool2"></p>WTTC 2017 Duesseldorf 充滿樂趣的andro商品展</button><br><br></div>  
        <button (click)="topFunction()" id="return-to-top" title="Go to top">Top</button>

        <!-- <div class="pagination">
          <a>&laquo;</a>
          <a (click)="gotoNew()" class="active">1</a> 
          <a (click)="gotoNew2()">2</a> 
          <a (click)="gotoNew3()">3</a> 
          <a (click)="gotoNew4()">4</a> 
          <a (click)="gotoNew5()">5</a> 
         
          <a (click)="gotoNew2()">&raquo;</a>
          
        </div>
          <div class="totalpage">
            共8頁
          </div> -->
          <button (click)="topFunction()" id="return-to-top" title="Go to top">Top</button>

       </div>
      
    `,
  providers:[NewService],
  styles: [`    
    .cool button{
    float: left;
    background-color: white;
    margin-left: 30px;
    border: none;
    
    }
    
    .cool{
    width:700px;
    font-size: 18px;
    font-weight: bold;
    }
    
   
    .container{
    margin-bottom: 30px;
    }

   
    `],
  inputs:['ptitle','pcontent']

})

export class NewComponent implements OnInit{
  constructor(private newservice:NewService,private router:Router){}
  new:New[];
  errorMessage:string;
  public ptitle:string;
  public pcontent:string;
  public more1 : boolean = false 
  public more2 : boolean = false
  public more3 : boolean = false
  public more4 : boolean = false
  public more5 : boolean = false
  public more6 : boolean = false
  public more7 : boolean = false
  public more8 : boolean = false
  public more9 : boolean = false
  public more10 : boolean = false
  public more11 : boolean = false



  ngOnInit(){
    this.getNews();
  }

  select2(title:string,content:string){
    this.newservice.add(title,content);
  }

  getNews(){
    this.newservice.getNews()
      .subscribe(
        products => this.new = products,
        error =>  this.errorMessage = <any>error);

  }
  gotoNew(){
    this.router.navigate(['new']);
  }
  gotoNew2(){
    this.router.navigate(['new2']);
  }
  gotoNew3(){
    this.router.navigate(['new3']);
  }
  gotoNew4(){
    this.router.navigate(['new4']);
  }
  gotoNew5(){
    this.router.navigate(['new5']);
  }
  gotoNew6(){
    this.router.navigate(['new6']);
  }
  gotoNew7(){
    this.router.navigate(['new7']);
  }
  gotoNew8(){
    this.router.navigate(['new8']);
  }

  show1(){
    this.more1 = true
  }
  show2(){
    this.more2 = true
  }
  show3(){
    this.more3 = true
  }
  show4(){
    this.more4 = true
  }
  show5(){
    this.more5 = true
  }
  show6(){
    this.more6 = true
  }
  show7(){
    this.more7 = true
  }
  show8(){
    this.more8 = true
  }
  show9(){
    this.more8 = true
  }
  show10(){
    this.more8 = true
  }
  show11(){
    this.more8 = true
  }

  gotoNewDetail(){
    this.router.navigate(['newdetail']);
  }
  gotoDetail1(){
    this.router.navigate(['detail1']);
  }
  gotoDetail2(){
    this.router.navigate(['detail2']);
  }
  gotoDetail3(){
    this.router.navigate(['detail3']);
  }
  gotoDetail4(){
    this.router.navigate(['detail4']);
  }
  gotoDetail5(){
    this.router.navigate(['detail5']);
  }
  gotoDetail6(){
    this.router.navigate(['detail6']);
  }
  gotoDetail7(){
    this.router.navigate(['detail7']);
  }
  gotoDetail8(){
    this.router.navigate(['detail8']);
  }
  gotoDetail9(){
    this.router.navigate(['detail9']);
  }
  gotoDetail10(){
    this.router.navigate(['detail10']);
  }
  gotoDetail11(){
    this.router.navigate(['detail11']);
  }
  gotoDetail12(){
    this.router.navigate(['detail12']);
  }
  gotoDetail13(){
    this.router.navigate(['detail13']);
  }
  gotoDetail14(){
    this.router.navigate(['detail14']);
  }
  gotoDetail15(){
    this.router.navigate(['detail15']);
  }
  gotoDetail16(){
    this.router.navigate(['detail16']);
  }
  gotoDetail17(){
    this.router.navigate(['detail17']);
  }
  gotoDetail18(){
    this.router.navigate(['detail18']);
  }
  gotoDetail19(){
    this.router.navigate(['detail19']);
  }
  gotoDetail20(){
    this.router.navigate(['detail20']);
  }
  gotoDetail21(){
    this.router.navigate(['detail21']);
  }
  gotoDetail22(){
    this.router.navigate(['detail22']);
  }
  gotoDetail23(){
    this.router.navigate(['detail23']);
  }
  gotoDetail24(){
    this.router.navigate(['detail24']);
  }
  gotoDetail25(){
    this.router.navigate(['detail25']);
  }
  gotoDetail26(){
    this.router.navigate(['detail26']);
  }
  gotoDetail27(){
    this.router.navigate(['detail27']);
  }
  gotoDetail28(){
    this.router.navigate(['detail28']);
  }
  gotoDetail29(){
    this.router.navigate(['detail29']);
  }
  gotoDetail30(){
    this.router.navigate(['detail30']);
  }
  gotoDetail31(){
    this.router.navigate(['detail31']);
  }
  gotoDetail32(){
    this.router.navigate(['detail32']);
  }
  gotoDetail33(){
    this.router.navigate(['detail33']);
  }
  gotoDetail34(){
    this.router.navigate(['detail34']);
  }
  gotoDetail35(){
    this.router.navigate(['detail35']);
  }
  gotoDetail36(){
    this.router.navigate(['detail36']);
  }
  gotoDetail37(){
    this.router.navigate(['detail37']);
  }
  gotoDetail38(){
    this.router.navigate(['detail38']);
  }
  gotoDetail39(){
    this.router.navigate(['detail39']);
  }
  gotoDetail40(){
    this.router.navigate(['detail40']);
  }
  gotoDetail41(){
    this.router.navigate(['detail41']);
  }
  gotoDetail42(){
    this.router.navigate(['detail42']);
  }
  gotoDetail43(){
    this.router.navigate(['detail43']);
  }
  gotoDetail44(){
    this.router.navigate(['detail44']);
  }
  gotoDetail45(){
    this.router.navigate(['detail45']);
  }
  gotoDetail46(){
    this.router.navigate(['detail46']);
  }
  gotoDetail47(){
    this.router.navigate(['detail47']);
  }
  gotoDetail48(){
    this.router.navigate(['detail48']);
  }
  gotoDetail49(){
    this.router.navigate(['detail49']);
  }
  gotoDetail50(){
    this.router.navigate(['detail50']);
  }
  gotoDetail51(){
    this.router.navigate(['detail51']);
  }
  gotoDetail52(){
    this.router.navigate(['detail52']);
  }
  gotoDetail53(){
    this.router.navigate(['detail53']);
  }
  gotoDetail54(){
    this.router.navigate(['detail54']);
  }
  gotoDetail55(){
    this.router.navigate(['detail55']);
  }
  gotoDetail56(){
    this.router.navigate(['detail56']);
  }
  gotoDetail57(){
    this.router.navigate(['detail57']);
  }
  gotoDetail58(){
    this.router.navigate(['detail58']);
  }
  gotoDetail59(){
    this.router.navigate(['detail59']);
  }
  gotoDetail60(){
    this.router.navigate(['detail60']);
  }
  gotoDetail61(){
    this.router.navigate(['detail61']);
  }
  gotoDetail62(){
    this.router.navigate(['detail62']);
  }
  gotoDetail63(){
    this.router.navigate(['detail63']);
  }
  gotoDetail64(){
    this.router.navigate(['detail64']);
  }
  gotoDetail65(){
    this.router.navigate(['detail65']);
  }
  gotoDetail66(){
    this.router.navigate(['detail66']);
  }
  gotoDetail67(){
    this.router.navigate(['detail67']);
  }
  gotoDetail68(){
    this.router.navigate(['detail68']);
  }
  gotoDetail69(){
    this.router.navigate(['detail69']);
  }
  gotoDetail70(){
    this.router.navigate(['detail70']);
  }
  gotoDetail71(){
    this.router.navigate(['detail71']);
  }
  gotoDetail72(){
    this.router.navigate(['detail72']);
  }
  gotoDetail73(){
    this.router.navigate(['detail73']);
  }
  gotoDetail74(){
    this.router.navigate(['detail74']);
  }
  gotoDetail75(){
    this.router.navigate(['detail75']);
  }
  gotoDetail76(){
    this.router.navigate(['detail76']);
  }
  gotoDetail77(){
    this.router.navigate(['detail77']);
  }
  gotoDetail78(){
    this.router.navigate(['detail78']);
  }
  gotoDetail79(){
    this.router.navigate(['detail79']);
  }
  gotoDetail80(){
    this.router.navigate(['detail80']);
  }
  gotoDetail81(){
    this.router.navigate(['detail81']);
  }
  gotoDetail82(){
    this.router.navigate(['detail82']);
  }
  gotoDetail83(){
    this.router.navigate(['detail83']);
  }
  gotoDetail84(){
    this.router.navigate(['detail84']);
  }
  gotoDetail85(){
    this.router.navigate(['detail85']);
  }
  gotoDetail86(){
    this.router.navigate(['detail86']);
  }
  gotoDetail87(){
    this.router.navigate(['detail87']);
  }
  gotoDetail88(){
    this.router.navigate(['detail88']);
  }
  gotoDetail89(){
    this.router.navigate(['detail89']);
  }
  gotoDetail90(){
    this.router.navigate(['detail90']);
  }
  gotoDetail91(){
    this.router.navigate(['detail91']);
  }
  gotoDetail92(){
    this.router.navigate(['detail92']);
  }
  gotoDetail93(){
    this.router.navigate(['detail93']);
  }
  gotoDetail94(){
    this.router.navigate(['detail94']);
  }
  gotoDetail95(){
    this.router.navigate(['detail95']);
  }
  gotoDetail96(){
    this.router.navigate(['detail96']);
  }
  gotoDetail97(){
    this.router.navigate(['detail97']);
  }
  gotoDetail98(){
    this.router.navigate(['detail98']);
  }
  gotoDetail99(){
    this.router.navigate(['detail99']);
  }
  gotoDetail100(){
    this.router.navigate(['detail100']);
  }
  gotoDetail101(){
    this.router.navigate(['detail101']);
  }
  gotoDetail102(){
    this.router.navigate(['detail102']);
  }
  gotoDetail103(){
    this.router.navigate(['detail103']);
  }
  gotoDetail104(){
    this.router.navigate(['detail104']);
  }
  gotoDetail105(){
    this.router.navigate(['detail105']);
  }
  gotoDetail106(){
    this.router.navigate(['detail106']);
  }
  gotoDetail107(){
    this.router.navigate(['detail107']);
  }
  gotoDetail108(){
    this.router.navigate(['detail108']);
  }
  gotoDetail109(){
    this.router.navigate(['detail109']);
  }
  gotoDetail110(){
    this.router.navigate(['detail110']);
  }
  gotoDetail111(){
    this.router.navigate(['detail111']);
  }
  gotoDetail112(){
    this.router.navigate(['detail112']);
  }
  gotoDetail113(){
    this.router.navigate(['detail113']);
  }
  gotoDetail114(){
    this.router.navigate(['detail114']);
  }
  gotoDetail115(){
    this.router.navigate(['detail115']);
  }
  gotoDetail116(){
    this.router.navigate(['detail116']);
  }
  gotoDetail117(){
    this.router.navigate(['detail117']);
  }
  gotoDetail118(){
    this.router.navigate(['detail118']);
  }
  gotoDetail119(){
    this.router.navigate(['detail119']);
  }
  gotoDetail120(){
    this.router.navigate(['detail120']);
  }
  gotoDetail121(){
    this.router.navigate(['detail121']);
  }
  gotoDetail122(){
    this.router.navigate(['detail122']);
  }
  gotoDetail123(){
    this.router.navigate(['detail123']);
  }
  gotoDetail124(){
    this.router.navigate(['detail124']);
  }
  gotoDetail125(){
    this.router.navigate(['detail125']);
  }
  gotoDetail126(){
    this.router.navigate(['detail126']);
  }
  gotoDetail127(){
    this.router.navigate(['detail127']);
  }
  gotoDetail128(){
    this.router.navigate(['detail128']);
  }
  gotoDetail129(){
    this.router.navigate(['detail129']);
  }
  gotoDetail130(){
    this.router.navigate(['detail130']);
  }
  gotoDetail131(){
    this.router.navigate(['detail131']);
  }
  gotoDetail132(){
    this.router.navigate(['detail132']);
  }
  gotoDetail133(){
    this.router.navigate(['detail133']);
  }
  gotoDetail134(){
    this.router.navigate(['detail134']);
  }
  gotoDetail135(){
    this.router.navigate(['detail135']);
  }
  gotoDetail136(){
    this.router.navigate(['detail136']);
  }
  gotoDetail137(){
    this.router.navigate(['detail137']);
  }
  gotoDetail138(){
    this.router.navigate(['detail138']);
  }
  gotoDetail139(){
    this.router.navigate(['detail139']);
  }
  gotoDetail140(){
    this.router.navigate(['detail140']);
  }
  gotoDetail141(){
    this.router.navigate(['detail141']);
  }
  gotoDetail142(){
    this.router.navigate(['detail142']);
  }
  gotoDetail143(){
    this.router.navigate(['detail143']);
  }
  gotoDetail144(){
    this.router.navigate(['detail144']);
  }
  gotoDetail145(){
    this.router.navigate(['detail145']);
  }
  gotoDetail146(){
    this.router.navigate(['detail146']);
  }
  gotoDetail147(){
    this.router.navigate(['detail147']);
  }
  gotoDetail148(){
    this.router.navigate(['detail148']);
  }
  gotoDetail149(){
    this.router.navigate(['detail149']);
  }
  gotoDetail150(){
    this.router.navigate(['detail150']);
  }
  gotoDetail151(){
    this.router.navigate(['detail151']);
  }
  gotoDetail152(){
    this.router.navigate(['detail152']);
  }
  gotoDetail153(){
    this.router.navigate(['detail153']);
  }
  gotoDetail154(){
    this.router.navigate(['detail154']);
  }
  gotoDetail155(){
    this.router.navigate(['detail155']);
  }
  gotoDetail156(){
    this.router.navigate(['detail156']);
  }
  gotoDetail157(){
    this.router.navigate(['detail157']);
  }
  gotoDetail158(){
    this.router.navigate(['detail158']);
  }
  gotoDetail159(){
    this.router.navigate(['detail159']);
  }
  gotoDetail160(){
    this.router.navigate(['detail160']);
  }
  gotoDetail161(){
    this.router.navigate(['detail161']);
  }
  gotoDetail162(){
    this.router.navigate(['detail162']);
  }
  gotoDetail163(){
    this.router.navigate(['detail163']);
  }
  gotoDetail164(){
    this.router.navigate(['detail164']);
  }
  gotoDetail165(){
    this.router.navigate(['detail165']);
  }
  gotoDetail166(){
    this.router.navigate(['detail166']);
  }
  gotoDetail167(){
    this.router.navigate(['detail167']);
  }
  gotoDetail168(){
    this.router.navigate(['detail168']);
  }
  gotoDetail169(){
    this.router.navigate(['detail169']);
  }
  gotoDetail170(){
    this.router.navigate(['detail170']);
  }
  gotoDetail171(){
    this.router.navigate(['detail171']);
  }
  gotoDetail172(){
    this.router.navigate(['detail172']);
  }
  gotoDetail173(){
    this.router.navigate(['detail173']);
  }
  gotoDetail174(){
    this.router.navigate(['detail174']);
  }
  gotoDetail175(){
    this.router.navigate(['detail175']);
  }
  gotoDetail176(){
    this.router.navigate(['detail176']);
  }
  gotoDetail177(){
    this.router.navigate(['detail177']);
  }
  gotoDetail178(){
    this.router.navigate(['detail178']);
  }
  gotoDetail179(){
    this.router.navigate(['detail179']);
  }
  gotoDetail180(){
    this.router.navigate(['detail180']);
  }
  gotoDetail181(){
    this.router.navigate(['detail181']);
  }
  gotoDetail182(){
    this.router.navigate(['detail182']);
  }
  gotoDetail183(){
    this.router.navigate(['detail183']);
  }
  gotoDetail184(){
    this.router.navigate(['detail184']);
  }
  gotoDetail185(){
    this.router.navigate(['detail185']);
  }
  gotoDetail186(){
    this.router.navigate(['detail186']);
  }
  gotoDetail187(){
    this.router.navigate(['detail187']);
  }
  gotoDetail188(){
    this.router.navigate(['detail188']);
  }
  gotoDetail189(){
    this.router.navigate(['detail189']);
  }
  gotoDetail190(){
    this.router.navigate(['detail190']);
  }
  gotoDetail191(){
    this.router.navigate(['detail191']);
  }
  gotoDetail192(){
    this.router.navigate(['detail192']);
  }
  gotoDetail193(){
    this.router.navigate(['detail193']);
  }
  gotoDetail194(){
    this.router.navigate(['detail194']);
  }
  gotoDetail195(){
    this.router.navigate(['detail195']);
  }
  gotoDetail196(){
    this.router.navigate(['detail196']);
  }
  gotoDetail197(){
    this.router.navigate(['detail197']);
  }
  gotoDetail198(){
    this.router.navigate(['detail198']);
  }
  gotoDetail199(){
    this.router.navigate(['detail199']);
  }
  gotoDetail200(){
    this.router.navigate(['detail200']);
  }
  gotoDetail201(){
    this.router.navigate(['detail201']);
  }
  gotoDetail202(){
    this.router.navigate(['detail202']);
  }
  gotoDetail203(){
    this.router.navigate(['detail203']);
  }
  gotoDetail204(){
    this.router.navigate(['detail204']);
  }
  gotoDetail205(){
    this.router.navigate(['detail205']);
  }
  gotoDetail206(){
    this.router.navigate(['detail206']);
  }
  gotoDetail207(){
    this.router.navigate(['detail207']);
  }
  gotoDetail208(){
    this.router.navigate(['detail208']);
  }
  gotoDetail209(){
    this.router.navigate(['detail209']);
  }
  gotoDetail210(){
    this.router.navigate(['detail210']);
  }
  gotoDetail211(){
    this.router.navigate(['detail211']);
  }
  gotoDetail212(){
    this.router.navigate(['detail212']);
  }
  gotoDetail213(){
    this.router.navigate(['detail213']);
  }
  gotoDetail214(){
    this.router.navigate(['detail214']);
  }
  gotoDetail215(){
    this.router.navigate(['detail215']);
  }
  gotoDetail216(){
    this.router.navigate(['detail216']);
  }
  gotoDetail217(){
    this.router.navigate(['detail217']);
  }
  gotoDetail218(){
    this.router.navigate(['detail218']);
  }
  gotoDetail219(){
    this.router.navigate(['detail219']);
  }
  gotoDetail220(){
    this.router.navigate(['detail220']);
  }
  topFunction() {
    $('body,html').animate({
      scrollTop : 0                       // Scroll to top of body
  }, 500);
}
 
  

}

$(window).scroll(function() {
  if ($(this).scrollTop() >= 50) {        // If page is scrolled more than 50px
      $('#return-to-top').fadeIn(200);    // Fade in the arrow
  } else {
      $('#return-to-top').fadeOut(200);   // Else fade out the arrow
  }
});





// WEBPACK FOOTER //
// ./src/app/news/new.component.ts